import { FormField } from '@zillow/constellation-10';
import AmenitiesInteriorFormField from './AmenitiesInteriorFormField';
import { WizardFormSectionContainer } from '../../../../styles/wizard';

const AmenitiesInteriorContainer = () => {
  return (
    <div data-testid="AmenitiesInteriorContainer">
      <WizardFormSectionContainer>
        <FormField>
          <AmenitiesInteriorFormField />
        </FormField>
      </WizardFormSectionContainer>
    </div>
  );
};

export default AmenitiesInteriorContainer;
